import { ListItem, ListItemButton, ListItemText, Typography } from "@mui/material";

import { SearchListItemLink } from "./SearchListItemLink";

export const PolicyListItem = (props: any) => {
  const { data, onClick } = props;
  const { content } = data;

  if (!content) {
    return null;
  }

  const displayName = `${content.label}`;

  return (
    <ListItem
      alignItems="flex-start"
      sx={{
        textDecoration: "none",
        "&:hover": {
          textDecoration: "none",
        },
        "& a": {
          textDecoration: "none",
        },
        "& a:hover": {
          textDecoration: "none",
        },
        px: 0,
      }}
      data-testid="policy"
    >
      <ListItemButton data={data} component={SearchListItemLink} onClick={onClick}>
        <ListItemText
          className="highlight"
          primary={
            <Typography color="textPrimary" variant="body2" gutterBottom>
              {displayName}
            </Typography>
          }
        />
      </ListItemButton>
    </ListItem>
  );
};
